import axios from "axios";
import { getStoredAccessToken } from "../../redux/store";

export { getStoredAccessToken };

export const getAuthHeaders = (fallbackAccount = "") => {
  const token = getStoredAccessToken();
  const authHeader = token
    ? (token.startsWith("Bearer ") ? token : `Bearer ${token}`)
    : (fallbackAccount || "");
  return {
    "X-Autobet-Client": "web",
    ...(authHeader ? { Authorization: authHeader } : {}),
  };
};

const Api = axios.create({
  baseURL:
    process.env.REACT_APP_API_URL || process.env.REACT_APP_API_KEY || "/api",
  responseType: "json",
  withCredentials: true,
  timeout: 20000,
  headers: { "X-Autobet-Client": "web" },
});

Api.interceptors.request.use((config) => {
  const accessToken = getStoredAccessToken();
  if (accessToken) {
    const authHeader = accessToken.startsWith("Bearer ")
      ? accessToken
      : `Bearer ${accessToken}`;
    if (!config.headers) {
      config.headers = {};
    }
    if (typeof config.headers.set === "function") {
      if (!config.headers.has("Authorization") && !config.headers.has("authorization")) {
        config.headers.set("Authorization", authHeader);
      }
    } else {
      if (!config.headers.Authorization && !config.headers.authorization) {
        config.headers.Authorization = authHeader;
      }
    }
  }
  return config;
});

export const token = "";
export const apiError = (error) => {
  const message = error.response?.data?.message;
  return Array.isArray(message)
    ? message.join(" ")
    : message || "We couldn't connect. Please try again.";
};
export default Api;

